import { Directive } from '@angular/core';

@Directive({
  selector: 'ng-template[uiTableRowActions]',
})
export class TableRowActionsDirective {
}
